import { ServiceConfig, get } from '@sales-center/common'
import { useCallback } from 'react'
import { toast } from 'react-toastify'

export function useDownloadErrorsHandler({ id: importId }) {
  type ImportUtilityTemplateDTO = {
    file: {
      contentType: string
      enableRangeProcessing: boolean
      entityTag: string | null
      fileContents: string
      fileDownloadName: string
      lastModified: string | null
    }
    name: string
    size: string
  }

  const onDownloadErrorsClick = useCallback(async () => {
    const response = await get(
      `${ServiceConfig.baseAPIUrl}/Import/download/errors/${importId}`,
    )

    if (response instanceof Response && response.ok) {
      const data: ImportUtilityTemplateDTO = await response.json()

      if (data) {
        const file = data.file
        const csvContent = atob(file.fileContents)
        const blob = new Blob([csvContent], { type: file.contentType })
        const objectURL = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = objectURL
        link.setAttribute('download', data.name)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(objectURL)
      }
    } else if (response.status === 400) {
      const errorMessage = await response.json()
      toast.error(errorMessage)
    }
  }, [importId])

  return {
    onDownloadErrorsClick,
  }
}
